<template>
  <div class="group-detail">
    <h1 class="common__main-title">Student Edit</h1>
    <div class="common__sub-title">
      <span>Details</span>
    </div>
    <div class="content-wrapper">
      <ValidationObserver ref="observer">
        <StudentInputForm :studentId="$route.params.id" ref="form"/>
        <div class="d-flex justify-content-between">
        <b-button
          pill
          variant="secondary"
          :to="{ name:'StudentDetail', params: { id: $route.params.id }}"
        >
            Back
        </b-button>
          <b-button
            pill
            variant="primary"
            @click="formValidate"
          >
            Confirm
          </b-button>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import StudentInputForm from '@/components/parts/students/StudentInputForm.vue';
import { ValidationObserver } from 'vee-validate';

export default Vue.extend({
  components: {
    StudentInputForm,
    ValidationObserver,
  },

  methods: {
    /* inputformのバリデーションを実行(veeValidate) */
    formValidate() {
      (this.$refs.observer as any).validate()
        .then((result: any) => {
          if (result) {
            this.gotoConfirm()
          }
        });
    },
    gotoConfirm() {
      this.$router.push({
        name: 'EditStudentConfirm',
        params: {
          id: this.$route.params.id,
          editingStudent: (this.$refs.form as any).content,
        },
      })
    },
  },
})
</script>

<style scoped>
.content-wrapper {
  background: #D8D8D8;
  padding: 20px 70px;
}

.button-container {
  display: flex;
  justify-content: space-between;
}
</style>
